/* ============================================================
 * edj-size-guide-page.js
 * Custom Element <edj-sg-page> — calculateur taille kimono/yukata
 * Lot 7 Batch B EDJ — page /pages/guide-des-tailles
 * Source : design-system/edj/project/page-size-guide.jsx (SizeGuideTool)
 *
 * Fichier distinct de edj-size-guide.js (qui gère le dialog modal sur PDP).
 *
 * Comportements :
 *  - Sélecteur garment (yukata/kimono/haori)
 *  - Sliders hauteur/poitrine/hanches (cm/inch toggle)
 *  - Choix coupe (Ajustée/Ample)
 *  - Calcul taille recommandée (algo de la maquette)
 *  - Tableau dynamique hydraté depuis data-sizes
 *  - Highlight ligne tableau matchant le résultat
 * ============================================================ */

(function () {
  if (window.customElements && window.customElements.get('edj-sg-page')) return;

  function cmToInch(v) { return Math.round(v / 2.54 * 10) / 10; }

  function computeSize(sizes, height, chest, hips, morpho) {
    if (!sizes.length) return null;
    var center = function (a, b) { return (a + b) / 2; };
    var scored = sizes.map(function (s) {
      var inH = height >= s.height_min && height <= s.height_max;
      var inC = chest ? chest >= s.chest_min && chest <= s.chest_max : false;
      var inP = hips ? hips >= s.hips_min && hips <= s.hips_max : false;
      var score = 0;
      if (inH) score += 3;
      if (inC) score += 2;
      if (inP) score += 1;
      score -= Math.abs(height - center(s.height_min, s.height_max)) * 0.05;
      if (chest) score -= Math.abs(chest - center(s.chest_min, s.chest_max)) * 0.04;
      if (hips) score -= Math.abs(hips - center(s.hips_min, s.hips_max)) * 0.03;
      if (morpho === 'between') score += 0.5;
      return { s: s, score: score };
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored[0].s;
  }

  function makeEl(tag, opts) {
    var el = document.createElement(tag);
    if (!opts) return el;
    if (opts.cls) el.className = opts.cls;
    if (opts.text != null) el.textContent = String(opts.text);
    if (opts.attrs) {
      Object.keys(opts.attrs).forEach(function (k) { el.setAttribute(k, opts.attrs[k]); });
    }
    return el;
  }

  class EdjSizeGuide extends HTMLElement {
    connectedCallback() {
      try {
        this.sizes = JSON.parse(this.getAttribute('data-sizes') || '[]');
      } catch (e) {
        this.sizes = [];
      }
      this.unit = 'cm';
      this.garment = 'yukata';
      this.morpho = 'regular';
      this.height = 165;
      this.chest = 88;
      this.hips = 94;

      this.tabs = this.querySelectorAll('[data-edj-garment]');
      this.unitBtns = this.querySelectorAll('[data-edj-unit]');
      this.sliders = this.querySelectorAll('[data-edj-slider]');
      this.morphoCards = this.querySelectorAll('.edj-sg-page__morpho-card');
      this.calcBtn = this.querySelector('[data-edj-calc]');
      this.resultEmpty = this.querySelector('[data-edj-result-empty]');
      this.resultFilled = this.querySelector('[data-edj-result]');
      this.resultBack = this.querySelector('[data-edj-result-back]');
      this.tbody = this.querySelector('[data-edj-size-tbody]');

      this._renderTable();
      this._bindEvents();
    }

    _bindEvents() {
      var self = this;
      this.tabs.forEach(function (t) {
        t.addEventListener('click', function () { self._setGarment(t.getAttribute('data-edj-garment')); });
      });
      this.unitBtns.forEach(function (b) {
        b.addEventListener('click', function () { self._setUnit(b.getAttribute('data-edj-unit')); });
      });
      this.sliders.forEach(function (sl) {
        var input = sl.querySelector('[data-edj-input]');
        var value = sl.querySelector('[data-edj-value]');
        var slider = sl.getAttribute('data-edj-slider');
        input.addEventListener('input', function () {
          var v = parseFloat(input.value);
          if (slider === 'height') self.height = v;
          if (slider === 'chest') self.chest = v;
          if (slider === 'hips') self.hips = v;
          if (self.unit === 'inch') {
            value.textContent = String(cmToInch(v));
          } else {
            value.textContent = String(Math.round(v));
          }
        });
      });
      this.morphoCards.forEach(function (c) {
        var radio = c.querySelector('input[type="radio"]');
        c.addEventListener('click', function () {
          self.morpho = radio.value;
          self.morphoCards.forEach(function (cc) {
            cc.classList.toggle('is-active', cc === c);
          });
          radio.checked = true;
        });
      });
      if (this.calcBtn) this.calcBtn.addEventListener('click', function () { self._calc(); });
      if (this.resultBack) this.resultBack.addEventListener('click', function () { self._back(); });
    }

    _setGarment(g) {
      this.garment = g;
      this.tabs.forEach(function (t) {
        var active = t.getAttribute('data-edj-garment') === g;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var garmentLabelEl = this.querySelector('[data-edj-result-garment]');
      if (garmentLabelEl) {
        var activeTabLabel = this.querySelector('[data-edj-garment].is-active .edj-sg-page__tab-label');
        if (activeTabLabel) garmentLabelEl.textContent = activeTabLabel.textContent;
      }
    }

    _setUnit(u) {
      this.unit = u;
      this.unitBtns.forEach(function (b) {
        var active = b.getAttribute('data-edj-unit') === u;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var suffix = u === 'inch' ? '″' : 'cm';
      this.querySelectorAll('[data-edj-suffix]').forEach(function (s) { s.textContent = suffix; });
      this.sliders.forEach(function (sl) {
        var input = sl.querySelector('[data-edj-input]');
        var value = sl.querySelector('[data-edj-value]');
        var v = parseFloat(input.value);
        value.textContent = u === 'inch' ? String(cmToInch(v)) : String(Math.round(v));
      });
    }

    _calc() {
      var reco = computeSize(this.sizes, this.height, this.chest, this.hips, this.morpho);
      if (!reco) return;
      this.querySelector('[data-edj-result-label]').textContent = reco.label;
      this.querySelector('[data-edj-result-jp]').textContent = reco.jp;
      var garmentLabel = this.querySelector('[data-edj-garment].is-active .edj-sg-page__tab-label');
      if (garmentLabel) this.querySelector('[data-edj-result-garment]').textContent = garmentLabel.textContent;
      this.querySelector('[data-edj-result-length]').textContent = String(reco.length);
      this.querySelector('[data-edj-result-sleeve]').textContent = String(reco.sleeve);
      this.querySelector('[data-edj-result-tour]').textContent = String(Math.round((reco.chest_min + reco.chest_max) / 2 + 18));

      // Description : DOM safe (createElement + textContent uniquement, aucun HTML brut)
      var descEl = this.querySelector('[data-edj-result-desc]');
      while (descEl.firstChild) descEl.removeChild(descEl.firstChild);
      descEl.appendChild(document.createTextNode('Pour ' + this.height + 'cm, tour de poitrine ' + this.chest + 'cm, hanches ' + this.hips + 'cm — la taille '));
      var strong = document.createElement('strong');
      strong.textContent = reco.label;
      descEl.appendChild(strong);
      var ample = this.morpho === 'between' ? ', avec l’ampleur que vous préférez' : '';
      descEl.appendChild(document.createTextNode(' tombe juste' + ample + '.'));

      this.resultEmpty.hidden = true;
      this.resultFilled.hidden = false;

      if (this.tbody) {
        this.tbody.querySelectorAll('tr').forEach(function (tr) {
          var isReco = tr.getAttribute('data-edj-row-label') === reco.label;
          tr.classList.toggle('is-reco', isReco);
        });
      }
    }

    _back() {
      this.resultEmpty.hidden = false;
      this.resultFilled.hidden = true;
      if (this.tbody) {
        this.tbody.querySelectorAll('tr').forEach(function (tr) {
          tr.classList.remove('is-reco');
        });
      }
    }

    _renderTable() {
      if (!this.tbody) return;
      while (this.tbody.firstChild) this.tbody.removeChild(this.tbody.firstChild);
      this.sizes.forEach(function (s) {
        var tr = makeEl('tr', { attrs: { 'data-edj-row-label': s.label } });

        // Cellule taille (label + jp + reco)
        var tdLabel = makeEl('td');
        var spanLabel = makeEl('span', { cls: 'edj-sg-page__td-label', text: s.label });
        var spanJp = makeEl('span', { cls: 'edj-sg-page__td-jp', text: s.jp, attrs: { lang: 'ja' } });
        var divReco = makeEl('div', { cls: 'edj-sg-page__td-reco', text: '★ Recommandé' });
        tdLabel.appendChild(spanLabel);
        tdLabel.appendChild(document.createTextNode(' '));
        tdLabel.appendChild(spanJp);
        tdLabel.appendChild(divReco);
        tr.appendChild(tdLabel);

        tr.appendChild(makeEl('td', { text: s.height_min + '–' + s.height_max + ' cm' }));
        tr.appendChild(makeEl('td', { text: s.chest_min + '–' + s.chest_max + ' cm' }));
        tr.appendChild(makeEl('td', { cls: 'edj-sg-page__td--desktop', text: s.hips_min + '–' + s.hips_max + ' cm' }));
        tr.appendChild(makeEl('td', { cls: 'edj-sg-page__td--desktop', text: s.length + ' cm' }));
        tr.appendChild(makeEl('td', { cls: 'edj-sg-page__td--desktop', text: s.sleeve + ' cm' }));

        this.tbody.appendChild(tr);
      }, this);
    }
  }

  if (window.customElements) {
    window.customElements.define('edj-sg-page', EdjSizeGuide);
  }
})();
